// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sFmv","right":"styles_right__1j0Yq"};